
import * as React from 'react';
import styled from 'styled-components';

import { Section } from '@process-advisor/process-miner/components/layout/section';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { AttributesGrid } from '@process-advisor/process-miner/filters/attributes/attributesGrid';
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { Event } from '@process-advisor/process-miner/api/events';
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

let optionsAttributeTypes = []
let optionsAttributes = [];

export const TaskAttributesTab = (mode) => {
    const sleep = ms => new Promise(r => setTimeout(r, ms));

    const [attributeType, setAttributeType] = React.useState<string>('');
    const [attribute, setAttribute] = React.useState<string>('');
    const [applyEnabled, setApplyEnabled] = React.useState<boolean>(true);

    const onAttributeTypeChange = (attributeType: string) => setAttributeType(attributeType);
    const onAttributeChange = (attribute: string) => setAttribute(attribute);

    React.useEffect(() => {
        optionsAttributes = []
        if (attributeType === apiProvider.getEntityUpper() ) {
            optionsAttributes = apiProvider.taskAttributes({});
        } else {
            optionsAttributes = apiProvider.eventAttributes({});
        }
        if (optionsAttributes.length > 0) {setAttribute(optionsAttributes[0].value);}
    }, [attributeType]);

    React.useEffect(() => {
        updateAttributes()
    }, []);

    React.useEffect(() => {
        const listener = () => {
            updateAttributes()
        };
        apiProvider.on(Event.resetTasksFilter, listener);
        apiProvider.on(Event.resetFilter, listener);
        return () => {
            apiProvider.off(Event.resetTasksFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
        };
    }, []);

    function updateAttributes () {

        let taskAttributes = apiProvider.taskAttributes()
        let eventAttributes = apiProvider.eventAttributes();
        optionsAttributes = []
        optionsAttributeTypes = []
        if (eventAttributes.length > 0) {
            var vtp = {}
            vtp['value'] = 'Event'
            vtp['label'] = 'Event'
            optionsAttributeTypes.push(vtp)
        }
        if (taskAttributes.length > 0) {
            var vtp = {}
            vtp['value'] = apiProvider.getEntityUpper() 
            vtp['label'] = apiProvider.getEntityUpper()
            optionsAttributeTypes.push(vtp)
        }
        setAttributeType(apiProvider.getEntityUpper())
        optionsAttributes = taskAttributes
    }

    async function onApply () {
        const tasksFilter = {
            ...(attribute ? { attribute } : {}),
            ...(attributeType ? { attributeType } : {}),
        };
        await openProgressModal({status: 'Processing Attributes Filters'})
        await sleep(50)
        await apiProvider.applyAttributesFilter({attribute: attribute, attributeType: attributeType, mode: mode.mode})
        setApplyEnabled(true)
        closeProgressModal()
    };

    return (
        <Wrapper>
            <SingleBlock width="50%">
                <Section title='Attribute Type'/>
            </SingleBlock>
            <SingleBlock width="50%">
                <Section title='Values'/>
            </SingleBlock>
            <SingleBlock width="50%">
                <Dropdown
                    options={optionsAttributeTypes}
                    onChange={onAttributeTypeChange}
                    value={attributeType}/>
            </SingleBlock>
            <SingleBlock width="50%">
                <Dropdown
                    options={optionsAttributes}
                    onChange={onAttributeChange}
                    value={attribute}/>
            </SingleBlock>
            <SingleBlock>
                <AttributesGrid
                    attribute={attribute}
                    setApplyEnabled={setApplyEnabled}
                    attributeType={attributeType}/>
            </SingleBlock>
            <SingleBlock width="40%"/>
            <SingleBlock width="20%">
                <Button label='Apply' onClick={onApply} disabled={applyEnabled}/>
            </SingleBlock>
            <SingleBlock width="40%"/>
            <AlertMessage/>
        </Wrapper>
    );
};
